<template>
  <f7-page>
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/dataBase/', { reloadCurrent: true })"
        >
          {{ $t('LeftPanel_title_bd') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ $t('LeftPanel_subtitle_locationClimate') }}</span>
      </template>
    </navbar>
    <div v-if="selection === 'GreenHouse'">
      <ClimateGreenHouse />
    </div>
    <div v-else>
      <ClimateOpenAir />
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex';
import navbar from '../../../components/navbar/NavBar.vue';
import ClimateGreenHouse from '../../../components/climate/climateGreenHouse/index.vue';
import ClimateOpenAir from '../../../components/climate/climateOpenAir/index.vue';

export default {
  name: 'DatabaseClimate',
  components: {
    navbar,
    ClimateGreenHouse,
    ClimateOpenAir,
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>

</style>
